import * as React from 'react';
import { actionType } from 'utils/constants';
import { useTabs } from './Tabs';
import { TabContainer } from './style';

export interface ITabProps {
  /**
   * Unique label of Tab to show when clicked.
   */
  label: string;
  onClickExtend?: any;
  children?: React.ReactNode;
  disabled?: boolean;
  id: number;
  singleTabWidth?: string;
}

export const Tab: React.FC<ITabProps> = (props: ITabProps) => {
  /**
   * This component allows changing of the active Tab.
   */
  const { activeTab, setActiveTab } = useTabs();
  const buttonId = (() => {
    if (props.id - activeTab === 1) return actionType.NEXT_Q1_TAB;
    if (props.id - activeTab === -1) return actionType.PREV_Q1_TAB;
    return '';
  })();

  return (
    <TabContainer
      disabled={props.disabled}
      isSelected={activeTab === props.id}
      singleTabWidth={props.singleTabWidth}
      data-testid={`tab${props.id}`}
      data-walkthrough={props.id}
    >
      <button
        id={buttonId}
        type="button"
        disabled={props.disabled}
        onClick={() => {
          if (props.onClickExtend) {
            props.onClickExtend(props.id);
          }
          setActiveTab(props.id);
        }}
      >
        {props.children}
      </button>
    </TabContainer>
  );
};
